var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1970_94216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.74998 16.6667C8.74998 16.9982 8.88168 17.3162 9.1161 17.5506C9.35052 17.785 9.66846 17.9167 9.99998 17.9167C10.3315 17.9167 10.6494 17.785 10.8839 17.5506C11.1183 17.3162 11.25 16.9982 11.25 16.6667V11.25H16.6666C16.9982 11.25 17.3161 11.1183 17.5505 10.8839C17.7849 10.6495 17.9166 10.3316 17.9166 10C17.9166 9.66852 17.7849 9.35058 17.5505 9.11616C17.3161 8.88174 16.9982 8.75004 16.6666 8.75004H11.25V3.33337C11.25 3.00185 11.1183 2.68391 10.8839 2.44949C10.6494 2.21507 10.3315 2.08337 9.99998 2.08337C9.66846 2.08337 9.35052 2.21507 9.1161 2.44949C8.88168 2.68391 8.74998 3.00185 8.74998 3.33337V8.75004H3.33331C3.00179 8.75004 2.68385 8.88174 2.44943 9.11616C2.21501 9.35058 2.08331 9.66852 2.08331 10C2.08331 10.3316 2.21501 10.6495 2.44943 10.8839C2.68385 11.1183 3.00179 11.25 3.33331 11.25H8.74998V16.6667Z",
    fill: "white",
    fillOpacity: 0.92
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1970_94216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.293a8e00b876adefdfd6726e5dff7d82.svg";
export { ForwardRef as ReactComponent };